import { Fragment, useContext, useState } from "react";
import { Spinner } from "react-bootstrap";
import Swal from "sweetalert2";
import { postRequestByAuth } from "../../../../../../function/helper";
import FactorContext from "../../context/FactorContext";
import PayLinkButton from "./PayLinkButton";

function PayButtons() {
  const { factorDetail } = useContext(FactorContext);
  const [loading, setLoading] = useState([false, false, false, false]);

  const isCod = () => {
    try {
      return factorDetail.shipments[0].item.isCod === 1;
    } catch (error) {
      return false;
    }
  };

  const isAnyLoading = () => {
    for (let i = 0; i < loading.length; i++) {
      if (loading[i] === true) return true;
    }
    return false;
  };

  const loadingUi = (
    <button className="buttonUi btn-success-style text-center text-white my-2">
      <div className="d-flex align-items-center justify-content-evenly">
        <Spinner
          style={{
            width: "20px",
            height: "20px",
            fontSize: "0.8rem",
          }}
        />
        <span className="me-1">در حال اجرا</span>
      </div>
    </button>
  );

  const sendRequest = async type => {
    setLoading(cur => {
      cur[type] = true;
      return [...cur];
    });

    const paylaod = {
      ids: factorDetail.shipments?.map(({ item }) => item.id),
      type,
      discountId: factorDetail.discountCode,
    };

    const response = await postRequestByAuth(`/totalpost/v1/payment`, paylaod);

    if (response.status === 200) {
      window.location.replace(response.data.path);
      return;
    }

    setLoading(cur => {
      cur[type] = false;
      return [...cur];
    });
    Swal.fire({
      icon: "error",
      text: response.message,
      showConfirmButton: true,
      confirmButtonText: "متوجه شدم",
      confirmButtonColor: "gray",
    });
  };

  return (
    <div className="d-flex flex-wrap column-gap-2 my-3">
      {isCod() ? (
        <Fragment>
          {loading[3] === true && loadingUi}
          {loading[3] === false && (
            <button
              className="buttonUi btn-success-style text-center text-white my-2"
              disabled={isAnyLoading()}
              onClick={() => sendRequest(3)}
            >
              <span>تایید و ثبت سفارش</span>
            </button>
          )}
        </Fragment>
      ) : (
        <Fragment>
          {loading[0] === true && loadingUi}
          {loading[0] === false && (
            <button
              className="buttonUi btn-success-style text-center text-white my-2"
              disabled={isAnyLoading()}
              onClick={() => sendRequest(0)}
            >
              <span> پرداخت با درگاه بانک</span>
            </button>
          )}

          {loading[1] === true && loadingUi}
          {loading[1] === false && (
            <button
              className="buttonUi btn-success-style text-center text-white my-2"
              disabled={isAnyLoading()}
              onClick={() => sendRequest(1)}
            >
              <span> پرداخت از کیف پول</span>
            </button>
          )}
        </Fragment>
      )}

      <PayLinkButton disabled={isAnyLoading()} />

      <button
        className="buttonUi btn-cancel-style my-2"
        disabled={isAnyLoading()}
        onClick={() => {
          window.history.back();
        }}
      >
        لغو و بازگشت به صفحه ی قبل
      </button>
    </div>
  );
}

export default PayButtons;
